import io from 'socket.io-client';
import { SOCKET_URL } from '../../api-config';
import store from '../../store';
import { generateToken } from '../../utils/sec';
import { RECEIVED_STUDENT } from '../aclass';
import { RECEIVED_NEW_EXERCISE, RECEIVED_NEW_STATUS, RECEIVED_PARTICIPANT } from '../competition';


export const SOCKET_CONNECTED = 'websocket/SOCKET_CONNECTED';
export const SOCKET_DISCONNECTED = 'websocket/SOCKET_DISCONNECTED';
export const RECEIVE_MESSAGE = 'websocket/RECEIVE_MESSAGE';
export const RECEIVE_NOTIFICATION = 'websocket/RECEIVE_NOTIFICATION';

export const socketConnected = (socketId) => ({
  type: SOCKET_CONNECTED,
  payload: { socketId }
});

export const socketDisconnected = () => ({
  type: SOCKET_DISCONNECTED
});

export const receiveMessage = (message) => ({
  type: RECEIVE_MESSAGE,
  payload: message
});

export const receiveNotification = (notification) => ({
  type: RECEIVE_NOTIFICATION,
  payload: notification
});

const initialState = {
  isConnected: false,
  socketId: null,
  messages: [],
  notifications: [],
};

export const socket_reducer = (state = initialState, action) => {
  switch (action.type) {
    case SOCKET_CONNECTED:
      return {
        ...state,
        isConnected: true
      };
    case SOCKET_DISCONNECTED:
      return {
        ...state,
        isConnected: false
      };

    default:
      return state;
  }
};

// src/socket/socketClient.js

// const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || 'http://localhost:1337';

let socket = null;

export const initSocket = (token = null) => {
  // Evitar múltiples conexiones
  if (socket?.connected) return socket;

  // Conectar con token de autenticación (opcional)
  socket = io(SOCKET_URL, {
    auth: {
      token: generateToken(), // JWT, si usas autenticación
    },
    reconnection: true,
    reconnectionAttempts: 5,
    reconnectionDelay: 1000,
  });

  // console.log('Websocket store:', store.getState().user.user);


  // Eventos
  socket.on('connect', () => {
    console.log('✅ Websocket: Conectado al servidor WebSocket:', socket.id);
    store.dispatch(socketConnected(socket.id));
  });

  socket.on('disconnect', () => {
    console.log('❌ Websocket: Desconectado del WebSocket');
    store.dispatch(socketDisconnected());
  });

  // Escuchar eventos personalizados
  socket.on('receive-message', (data) => {
    console.log('📩 Websocket: Mensaje recibido:', data);

    const storeUser = store.getState().user.user;

    if (storeUser && storeUser.teacher && data.message) {
      const message = data.message;
      console.log('message:', message);

      if (message.status) {
        store.dispatch({
          type: RECEIVED_NEW_STATUS,
          newStatus: message.status
        });
      } else if (message.exercise) {
        store.dispatch({
          type: RECEIVED_NEW_EXERCISE,
          newCurrentExercise: message.exercise,
          newStartedTime: message.startedTime,
        });
      }
    }
  });

  socket.on('notification', (data) => {
    console.log('🔔 Websocket: Notificación recibida:', data);
    store.dispatch(receiveNotification(data));
  });

  // Puedes escuchar más eventos: 'user-online', 'task-updated', etc.
  socket.on('new-student', (data) => {
    console.log('📩 Websocket: new-student:', data);
    store.dispatch({
      type: RECEIVED_STUDENT,
      student: data
    });
  });

  socket.on('update-student', (data) => {
    console.log('📩 Websocket: update-student:', data);
    store.dispatch({
      type: RECEIVED_STUDENT,
      student: data
    });
  });
  
  socket.on('add-participant', (data) => {
    console.log('📩 Websocket: add-participant:', data);
    store.dispatch({
      type: RECEIVED_PARTICIPANT,
      participant: data
    });
  });

  socket.on('new-current-exercose', (data) => {
    console.log('📩 Websocket: new-current-exercose:', data);
    store.dispatch({
      type: RECEIVED_NEW_EXERCISE,
      newCurrentExercise: data.exercise,
      newStartedTime: data.startedTime,
    });
  });

  return socket;
};

export const getSocket = () => socket;

export const disconnectSocket = () => {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
};

// Funciones para emitir eventos
export const emitJoinRoom = (room) => {
  if (socket) {
    socket.emit('join-room', room);
    console.log('Websocket: unido a las sala:', room);
  }
};

export const emitLeaveRoom = (room) => {
  if (socket) socket.emit('leave-room', room);
};

export const emitSendMessage = (data) => {
  if (socket) socket.emit('send-message', data);
};

export const joinRoom = (room) => {
  initSocket();
  emitJoinRoom(room);
};

export const sendMessageToRoom = (message, room) => {
    console.log('📩 Websocket: sendMessageToRoom:', message);

  if (socket) socket.emit('send-message', { room, message });
};
